export default __webpack_public_path__ + "static/media/frame2.c092678c.svg";